export default __webpack_public_path__ + "static/media/key.bfa5ba2b.svg";